<div class="selector">
    <div class="period" [ngClass]="theme">{{ displayedPeriod }}</div>

    <div>
        <svg:svg [ngClass]="theme" x="0" y="0" [attr.width]="width"
                 [attr.height]="(open ? 24 * ranges.length : 0) + 24">

            <svg:svg height="24" [attr.width]="width" class="range-picker" (click)="onClickOpen()" *ngIf="!open">
                <svg:rect x="0" [attr.width]="width" height="24"></svg:rect>
                <svg:text x="10" y="50%" dominant-baseline="middle">{{ 'BACKUP.RANGEKEYS.' + select | translate}}
                </svg:text>
                <svg:svg height="24" width="24" [attr.x]="width - 24" fill="white" viewBox="0 0 24 24">
                    <svg:path class="arrow" d="m 13,9 -5,5 -5,-5" *ngIf="!open" />
                    <svg:path class="arrow" d="m 3,13 5,-5 5,5" *ngIf="open" />
                </svg:svg>
            </svg:svg>

            <svg:svg x="direction === 'top' ? -72 : 0" y="24" [attr.width]="width + 4"
                     [attr.height]="4 + 24 * ranges.length" *ngIf="open">
                <svg:rect x="0" y="0" [attr.width]="width + 4" [attr.height]="4 + 24 * ranges.length" class="border">
                </svg:rect>
                <svg:svg *ngFor="let range of ranges; index as idx" x="2" [attr.y]="2 + idx * 24" [attr.width]="width"
                         height="24" (click)="onRangeChanged(range)" class="range-chooser">
                    <svg:rect class="range" x="0" [attr.width]="width" height="24"></svg:rect>
                    <svg:text class="range" x="10" y="50%" dominant-baseline="middle">
                        {{ 'BACKUP.RANGEKEYS.' + range | translate}}</svg:text>
                </svg:svg>
            </svg:svg>

        </svg:svg>
    </div>
</div>
